import type { ComponentInterface, EventEmitter } from '@stencil/core';
import { Component, Host, h, Prop, Event, Element } from '@stencil/core';

@Component({
  tag: 'jackery-tab-nav',
  styleUrl: 'jackery-tab-nav.css',
  shadow: true,
})
export class JackeryTabNav implements ComponentInterface {
  @Element() el!: HTMLJackeryTabNavElement;
  /**
   * tab选中状态
   */
  @Prop() active: boolean = false;

  /**
   * Tab样式类型
   */
  @Prop() type?: 'line' | 'fill' = 'line';

  /**
   * tab 禁用状态
   */
  @Prop() disabled: boolean = false;

  /**
   * 深色模式	
   */
  @Prop() dark: boolean = false;

  /**
   * 当前激活的 tab	
   */
  @Prop({reflect: true}) name: string = '0';

  /**
   * Tab item 背景颜色	
   * type 属性为 fill 时候生效
   */
  @Prop() tabbg: string = '#f5f5f5';

  /**
  * Tab item 选中状态背景颜色	
  * type 属性为 fill 时候生效
  */
  @Prop() activebg: string = '#FD5000';

  
  /**
   * 点击触发change
   */
  @Event({ eventName: 'navchange' }) navChange!:EventEmitter;

  private handleClick = () => {
    if (this.active || this.disabled) {
      return;
    }
    this.navChange.emit({
      name: this.name,
      label: this.el.innerHTML || ""
    })
  };

  render() {
    return (
      <Host
        class={{
          [`active`]: this.active,
          [`disabled`]: this.disabled,
          [`type--${this.type}`]: true,
        }}

        style={{
          "--nav-bg": this.tabbg,
          "--nav-active-bg": this.activebg,
        }}
      >
        <div class="jackery-tab-nav" onClick={this.handleClick} part="root">
          <slot></slot>
        </div>
      </Host>
    );
  }
}
